import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

import Button from "../../Button";
import { useRegistrationForm } from "../core/RegistrationFormProvider";
import { RegistrationFormIndicator } from "../RegistrationFormIndicator";
import { generatePickupValidationSchema } from "../../../utils/validationSchemas";
import Timer from "../Timer";

export default function PickupInformationTab() {
	const { isLoading, cities, registerData, setRegisterData } = useRegistrationForm();
	console.log({isLoading});
	const { step } = registerData || {};

	const onSubmit = (values) => {
		console.log(values);
		setRegisterData({
			...registerData,
			pickup_information: values,
			step: step + 1,
		});
	};

	// Create initial values for each child
	const getInitialValues = () => {
		const initialValues = {};
		(registerData?.selectedKids || []).forEach((kid) => {
			initialValues[kid.child_name] = {
				// pickup_city: "",
				// pickup_school: "",
				pickup_type: "",
				pickup_contact_name: "",
				pickup_contact_phone: "",
				pickup_contact_closeness: "",
			};
		});
		console.log({ ...initialValues, pickup_agree: false, comment: "", })
		return { ...initialValues, pickup_agree: false, comment: "", };
	};

	const validationSchema = generatePickupValidationSchema(registerData?.selectedKids);

	const formik = useFormik({
		initialValues: getInitialValues(),
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	});

	console.log(formik);

	// useEffect(() => {
	// 	if (!registerData) {
	// 		return;
	// 	}

	// 	const currentValues = registerData?.pickup_information;

	// 	/**
	// 	 * Set the form values from the saved data, but only fields that exist in the initial values.
	// 	 */
	// 	let newValues = {};
	// 	registerData?.selectedKids.forEach((kid) => {
	// 		newValues[kid.child_name] = {};
	// 		for (let key in formik.initialValues[kid.child_name]) {
	// 			if (currentValues && currentValues[kid.child_name] && currentValues[kid.child_name].hasOwnProperty(key)) {
	// 				newValues[kid.child_name][key] = currentValues[kid.child_name][key];
	// 			} else {
	// 				newValues[kid.child_name][key] = formik.initialValues[kid.child_name][key];
	// 			}
	// 		}
	// 	});

	// 	formik.setValues(newValues);
	// }, [registerData]);

	if (!cities) {
		return null;
	}

	const { isSubmitting, touched, errors, values } = formik;
	console.log(values, isSubmitting, errors);

	return (
		<div className="max-w-5xl w-full mx-auto my-20 pt-20 pb-5 px-4 md:px-10 text-center rounded-xl bg-opacity-50 bg-white text-white">
			<RegistrationFormIndicator />
			<form onSubmit={formik.handleSubmit} aria-disabled={isLoading || isSubmitting}>
				<div className=" md:gap-8 text-right mx-auto text-md w-full">
					<div className="md:col-span-2">
						<div className="text-center mb-4">
							<span className="font-bold">תחנת איסוף</span>
						</div>
					</div>

					{(registerData?.selectedKids || []).map((kid) => {
						console.log(kid);
						const kidValues = values[kid.child_name] || {};
						const kidTouched = touched[kid.child_name] || {};
						const kidErrors = errors[kid.child_name] || {};
						console.log(kidValues, kidTouched, kidErrors);

						let schools = [];
						if (kidValues.pickup_city) {
							let city = cities.filter((c) => c.id === parseInt(kidValues.pickup_city)).shift();
							if (city && city.schools) {
								schools = city.schools;
							}
						}

						return (
							<div key={kid.child_name} className="grid relative md:grid-cols-2 md:gap-8 border border-gray-300 p-4 mb-4">
								<h3 className="font-bold absolute top-[-30px] right-0 p-2">{kid.child_name}</h3>
								<div className="col-span-1">
									{/* Pickup city */}
									<div className="mb-4 flex gap-4">
										<div className="w-full md:flex items-center gap-2">
											<div className="w-full md:w-1/5 pb-4">
												<label className="font-semibold" htmlFor={`pickup_city_${kid.child_name}`}>
													עיר
												</label>
											</div>
											<div className="relative w-full md:w-4/5 pb-4">
											    שיבא
												{/* <select 
													id={`pickup_city_${kid.child_name}`}
													name={`${kid.child_name}.pickup_city`}
													value={kidValues.pickup_city}
													onChange={(e) => {
														formik.setFieldValue(`${kid.child_name}.pickup_city`, e.target.value);
														formik.setFieldValue(`${kid.child_name}.pickup_school`, "");
													}}
													onBlur={formik.handleBlur}
													disabled={isLoading || isSubmitting}
													className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_city && kidErrors.pickup_city ? "border-red-600" : "border-transparent"}`}
												>
													<option value="">בחר/י את העיר שממנה נאסוף את {kid.child_name}</option>
													{cities
														.sort((a, b) => {
															const letters = "אבגדהוזחטיכסעפצקרשת";
															const aIndex = letters.indexOf(a.name[0]);
															const bIndex = letters.indexOf(b.name[0]);
															return aIndex - bIndex;
														})
														.map((city) => (
															<option key={city.id} value={city.id}>
																{city.name}
															</option>
														))}
												</select>
												{kidTouched.pickup_city && kidErrors.pickup_city && (
													<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
														{kidErrors.pickup_city}
													</span>
												)} */}
											</div>
										</div>
									</div>
									{/* Pickup school */}
									{/* <div className="mb-4 flex gap-4">
										<div className="w-full md:flex items-center gap-2">
											<div className="w-full md:w-1/5 pb-4">
												<label className="font-semibold" htmlFor={`pickup_school_${kid.child_name}`}>
													בית ספר
												</label>
											</div>
											<div className="relative w-full md:w-4/5 pb-4">
												<select
													id={`pickup_school_${kid.child_name}`}
													name={`${kid.child_name}.pickup_school`}
													value={kidValues.pickup_school}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													disabled={isLoading || isSubmitting}
													className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_school && kidErrors.pickup_school ? "border-red-600" : "border-transparent"}`}
												>
													<option value="">בחר/י את בית הספר שממנו נאסוף את {kid.child_name}</option>
													{schools
														.sort((a, b) => {
															const letters = "אבגדהוזחטיכסעפצקרשת";
															const aIndex = letters.indexOf(a.name[0]);
															const bIndex = letters.indexOf(b.name[0]);
															return aIndex - bIndex;
														})
														.map((item) => (
															<option key={item.id} value={item.id}>
																{item.name}
															</option>
														))}
												</select>
												{kidTouched.pickup_school && kidErrors.pickup_school && (
													<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
														{kidErrors.pickup_school}
													</span>
												)}
											</div>
										</div>
									</div> */}
								</div>
								<div className="col-span-1">
									{/* Pickup type */}
									<div className="mb-4 flex gap-4">
										<div className="w-full md:flex items-center gap-2">
											<div className="w-full md:w-1/5 pb-4">
												<label className="font-semibold" htmlFor={`pickup_type_${kid.child_name}`}>
													איסוף הילד/ה
												</label>
											</div>
											<div className="relative w-full md:w-4/5 pb-4">
												<select 
													id={`pickup_type_${kid.child_name}`}
													name={`${kid.child_name}.pickup_type`}
													value={kidValues.pickup_type}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													disabled={isLoading || isSubmitting}
													className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_type && kidErrors.pickup_type ? "border-red-600" : "border-transparent"}`}
												>
													<option value="">בחר/י את אופן האיסוף</option>
													<option value="יאסף בליווי אדם מבוגר מטעם המשפחה">יאסף בליווי אדם מבוגר מטעם המשפחה</option>
													<option value="ילדי חוזר הביתה בכוחות עצמו">ילדי חוזר הביתה בכוחות עצמו</option>
												</select>
												{kidTouched.pickup_type && kidErrors.pickup_type && (
													<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
														{kidErrors.pickup_type}
													</span>
												)}
											</div>
										</div>
									</div>
									{/* Pickup contact name */}
									{kidValues.pickup_type === "יאסף בליווי אדם מבוגר מטעם המשפחה" && (
										<div className="mb-4 flex gap-4">
											<div className="w-full md:flex items-center gap-2">
												<div className="w-full md:w-1/5 pb-4">
													<label className="font-semibold" htmlFor={`pickup_contact_name_${kid.child_name}`}>
														שם האדם האוסף
													</label>
												</div>
												<div className="relative w-full md:w-4/5 pb-4">
													<input
														id={`pickup_contact_name_${kid.child_name}`}
														name={`${kid.child_name}.pickup_contact_name`}
														value={kidValues.pickup_contact_name}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														disabled={isLoading || isSubmitting}
														className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_contact_name && kidErrors.pickup_contact_name ? "border-red-600" : "border-transparent"}`}
														type="text"
													/>
													{kidTouched.pickup_contact_name && kidErrors.pickup_contact_name && (
														<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
															{kidErrors.pickup_contact_name}
														</span>
													)}
												</div>
											</div>
										</div>
									)}
									{/* Pickup contact closeness */}
									{kidValues.pickup_type === "יאסף בליווי אדם מבוגר מטעם המשפחה" && (
										<div className="mb-4 flex gap-4">
											<div className="w-full md:flex items-center gap-2">
												<div className="w-full md:w-1/5 pb-4">
													<label className="font-semibold" htmlFor={`pickup_contact_closeness_${kid.child_name}`}>
														קרבת האדם האוסף
													</label>
												</div>
												<div className="relative w-full md:w-4/5 pb-4">
													<input
														id={`pickup_contact_closeness_${kid.child_name}`}
														name={`${kid.child_name}.pickup_contact_closeness`}
														value={kidValues.pickup_contact_closeness}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														disabled={isLoading || isSubmitting}
														className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_contact_closeness && kidErrors.pickup_contact_closeness ? "border-red-600" : "border-transparent"}`}
														type="text"
													/>
													{kidTouched.pickup_contact_closeness && kidErrors.pickup_contact_closeness && (
														<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
															{kidErrors.pickup_contact_closeness}
														</span>
													)}
												</div>
											</div>
										</div>
									)}
									{/* Pickup contact phone */}
									{kidValues.pickup_type === "יאסף בליווי אדם מבוגר מטעם המשפחה" && (
										<div className="mb-4 flex gap-4">
											<div className="w-full md:flex items-center gap-2">
												<div className="w-full md:w-1/5 pb-4">
													<label className="font-semibold" htmlFor={`pickup_contact_phone_${kid.child_name}`}>
														טלפון האדם האוסף
													</label>
												</div>
												<div className="relative w-full md:w-4/5 pb-4">
													<input
														id={`pickup_contact_phone_${kid.child_name}`}
														name={`${kid.child_name}.pickup_contact_phone`}
														value={kidValues.pickup_contact_phone}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														disabled={isLoading || isSubmitting}
														className={`px-4 py-3 rounded-2xl w-full text-black text-sm border-2 ${kidTouched.pickup_contact_phone && kidErrors.pickup_contact_phone ? "border-red-600" : "border-transparent"}`}
														type="text"
													/>
													{kidTouched.pickup_contact_phone && kidErrors.pickup_contact_phone && (
														<span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">
															{kidErrors.pickup_contact_phone}
														</span>
													)}
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						);
					})}
				</div>
				{/* <div className="mt-0 text-right">
					<div className={`w-full text-black bg-opacity-20 p-7 rounded-3xl text-center ${values && values.pickup_agree ? "bg-green-400 border border-green-700" : "bg-red-400 border border-red-700"}`}>
						<strong className={`${values && values.pickup_agree ? "text-green-600" : "text-black"}`}>
							לתשומת ליבך: זוהי נקודת האיסוף של ילדך ולא ניתן לשנות אותה לאחר הבחירה.
							<br />
							על מנת להירשם עם חברים נוספים, על החברים לסמן נקודת איסוף זהה.
						</strong>
					</div>
					<div className="mt-2">
						<div className="relative flex items-center pb-4">
							<label className="block w-full text-right" htmlFor="pickup_agree">
								<input id="pickup_agree" {...formik.getFieldProps("pickup_agree")} disabled={isLoading || isSubmitting} type="checkbox" className="mr-2" checked={values?.pickup_agree} />
								<span>אני מאשר/ת את נקודת האיסוף שבחרתי</span>
							</label>
							{touched && touched.pickup_agree && errors && errors.pickup_agree && <span className="block absolute bottom-0 right-0 text-xs leading-none text-red-700">{errors.pickup_agree}</span>}
						</div>
					</div>
				</div> */}
				<div className="mt-6 text-right">
					<label className="font-semibold text-right" htmlFor="comment">
						הערות נוספות  <span className="text-sm font-bold text-black">* מומלץ לרשום את שמות החברים איתם תרצו שילדכם יהיה באותו האוטובוס. נעשה את מיטב מאמצינו.</span> 
					</label>
					<div className="mt-2">
						<textarea id="comment" placeholder="יש לרשום האם הילד צמחוני/טבעוני/צליאקי ומי חבריו" {...formik.getFieldProps("comment")} className="px-4 py-3 h-32 rounded-2xl w-full text-black text-sm"></textarea>
					</div>
				</div>
				<div className="flex justify-between items-center mt-8">
					<Button
						onClick={() => {
							setRegisterData({
								...registerData,
								step: step - 1,
							});
						}}
						disabled={isLoading || isSubmitting}>
						חזור
					</Button>
					<Timer />
					<Button type="submit" disabled={isLoading}>
						{isSubmitting ? "שומר..." : "המשך"}
					</Button>
				</div>
			</form>
		</div>
	);
}
